import React, { useEffect, memo, useRef } from 'react';
import { T } from '@tribeplatform/react-components/i18n';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { useDocument } from '@tribeplatform/react-ui-kit/hooks';
const InjectScript = memo(({ html }) => {
    const divRef = useRef(null);
    const { document } = useDocument();
    useEffect(() => {
        if (divRef.current === null) {
            return;
        }
        const doc = document.createRange().createContextualFragment(html);
        divRef.current.innerHTML = '';
        divRef.current.appendChild(doc);
    }, [divRef, html]);
    const props = {
        className: 'flex justify-center items-center',
        dangerouslySetInnerHTML: { __html: html },
    };
    return React.createElement("div", Object.assign({ ref: divRef }, props));
});
export const HtmlScriptBlock = ({ html, wrapper, }) => {
    const htmlContent = html ? (React.createElement(InjectScript, { html: html })) : (React.createElement("p", null,
        React.createElement(T, { id: "Blocks.HtmlScript.InsertHtmlInThisBlock", defaultMessage: "Insert html text in this block" })));
    if (wrapper === 'none')
        return htmlContent;
    if (wrapper === 'card')
        return React.createElement(Card, null, htmlContent);
    return (React.createElement(Card, null,
        React.createElement(Card.Content, null, htmlContent)));
};
//# sourceMappingURL=Block.js.map